import PropTypes from 'prop-types';

export const ConsumerReviewsParams = PropTypes.shape({
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  submodel: PropTypes.string,
  styleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});
